import { fileUpload } from '@/js/common/cosUpload';

/**
 * 上传文件到腾讯云 COS（保持旧签名以兼容现有调用）
 *
 * 历史上前两个参数是 lib.api 实例与阿里云 auth/get 接口地址，
 * 改为腾讯云 COS 直传后已不再需要，保留形参仅为兼容调用方写法。
 *
 * @param {Object} _api      兼容旧调用（lib.api），已忽略
 * @param {String} _url      兼容旧调用（auth/get 地址），已忽略
 * @param {Object} file      el-upload 文件对象（含 name 与原始 File: raw）
 * @param {Function} [onProgress] 进度回调函数，参数为 0-100 的百分比
 * @returns {Promise<String>} 上传后的文件 URL
 */
async function upFile(_api, _url, file, onProgress) {
  const raw = file.raw || file; // el-upload 的原始 File 在 raw 上
  const obj = { name: file.name };
  const res = await fileUpload(raw, obj, 'home', onProgress);
  return res.url;
}

export default upFile;
